import { render, staticRenderFns } from "./ProductDistributionChart.vue?vue&type=template&id=5a5b2fcc"
import script from "./ProductDistributionChart.vue?vue&type=script&lang=js"
export * from "./ProductDistributionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports